import React from 'react'
import { Recordvoice } from '../../../../assets/Logos/Icons'
import '../../../../components/WaitingRoom/WaitingRoom.css'

function RecordingModal({ state, handleClose, handleOk, okText, canceltext, message }) {
    return (
        <>
            {
                state ? (
                    <div className="wr-modal-overlay">
                        <div className="wr-modal">
                           
                            <p className="wr-modal-text">
                                As required by Dubai Health telemedicine guidelines, this consultation’s audio will be recorded for clinical and quality purposes. By staying on this call, you agree to the recording.
                            </p>
                            <div className="wr-modal-buttons">
                                <button 
                                    className="popup-button wr-modal-stay" 
                                    onClick={() => { handleClose(null) }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null
            }
        </>
    )
}

export default RecordingModal